import { useState } from 'react'
import clsx from 'clsx'
import { Icon } from '@iconify/react'

import { Button } from '@pepper/ui'
import ChangeKeywordModal from 'container/SEOTools/ContentGapReport/ChangeKeywordModal/ChangeKeywordModal'

import { GapReport, TargetKeywordStats } from '@pepper/utils/src/types/seo'
import { getFormattedValue } from '../CRRDrawer.utils'

import styles from './StatHeader.module.css'

type Props = {
  statsData: {
    target_keyword?: string
    stats: {
      title: string
      value?: number
    }[]
  }
  report?: GapReport
  targetKeywordStats: TargetKeywordStats
}

const StatHeader = ({ statsData, report, targetKeywordStats }: Props) => {
  const isPublic = window.location.pathname.includes('content-refresh-report')
  const [openModal, setOpenModal] = useState(false)

  return (
    <div className={styles.header}>
      <div className={styles.container}>
        <div className={styles.targetKeyword}>
          <div>
            <p className={styles.targetKeywordTitle}>Target keyword</p>
            <p className={styles.targetKeywordText}>
              <span>{statsData.target_keyword}</span>
            </p>
          </div>
          {!isPublic ? (
            <Button
              className={styles.btnEditKeyword}
              onClick={() => setOpenModal(true)}
              icon={<Icon icon="lucide:file-edit" />}
              size="small"
            />
          ) : null}
        </div>
        <div className={styles.statCard}>
          {statsData.stats.map(stat => {
            return stat.title === 'Potential Traffic' ? (
              <div key={stat.value} className={styles.greenStatCard}>
                <span className={styles.statIcon}>
                  <Icon icon="lucide:trending-up" />
                </span>
                <div>
                  <p className={clsx(styles.statValue, styles.greenText)}>
                    {getFormattedValue(stat.title, stat.value)}
                  </p>
                  <p className={clsx(styles.statTitle, styles.greenText)}>
                    {stat.title}
                  </p>
                </div>
              </div>
            ) : (
              <div key={stat.value}>
                <p className={styles.statValue}>
                  {getFormattedValue(stat.title, stat?.value)}
                </p>
                <p className={styles.statTitle}>{stat.title}</p>
              </div>
            )
          })}
        </div>
        {targetKeywordStats && report ? (
          <ChangeKeywordModal
            open={openModal}
            setOpen={setOpenModal}
            report={report}
            targetKeywordStats={targetKeywordStats}
          />
        ) : null}
      </div>
    </div>
  )
}

export default StatHeader
